import { Grid } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { CheckBox } from "components/Form/FormikControls";
import { getNeverEverEligibilityStatusByConsignmentId } from "selectors";
import { NeverEverEligibilityStatus } from "constants/greenhams";
import { NeverEverIntegrationStatus } from "components/NeverEver/NeverEverIntegration";
import { withAttributeNamespace } from "./util";

interface IsNeeAccreditedFieldProps {
  readOnly?: boolean;
  consignmentId: string;
}

export function IsNeeAccreditedField(
  props: IsNeeAccreditedFieldProps,
): React.JSX.Element {
  const { readOnly, consignmentId } = props;

  const eligibilityStatus: NeverEverEligibilityStatus = useSelector(
    getNeverEverEligibilityStatusByConsignmentId(consignmentId),
  );

  const isDisabled =
    readOnly || eligibilityStatus !== NeverEverEligibilityStatus.ELIGIBLE;

  return (
    <Grid container direction="row">
      <CheckBox
        name={withAttributeNamespace("isNeeAccredited")}
        disabled={isDisabled}
        label={
          <NeverEverIntegrationStatus
            consignmentId={consignmentId}
            showGenericTooltip
          />
        }
      />
    </Grid>
  );
}
